module.exports = __webpack_public_path__ + "img/hengda.d5e1efea.png";